export default __webpack_public_path__ + "static/media/disenocerrado.8339962a.svg";